/**
 * Valida CPF client-side — mesmo algoritmo usado no backend
 * (utils.IsValidCPF em internal/utils/cpf.go).
 * Serve como UX imediata; o backend revalida server-side.
 */

const NON_DIGIT = /\D/g;

export function isValidCPF(raw: string): boolean {
  const digits = raw.replace(NON_DIGIT, '');
  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  return checkDigit(digits, 10) && checkDigit(digits, 11);
}

function checkDigit(digits: string, factor: number): boolean {
  let sum = 0;
  for (let i = 0; i < factor - 1; i++) {
    sum += parseInt(digits[i], 10) * (factor - i);
  }
  const remainder = (sum * 10) % 11;
  const expected = remainder === 10 ? 0 : remainder;
  return expected === parseInt(digits[factor - 1], 10);
}
